import React, { useContext } from 'react';
import styles from './nosub.module.css';
import { Button } from 'app/shared/button';
import { SubscriptionPurchaseContext } from 'contexts/checkout/subscription';

export const NoSubscription = () => {
  const { openModal, setModuleCode } = useContext(SubscriptionPurchaseContext);

  const handleClick = () => {
    setModuleCode('campaign');
    openModal();
  };

  return (
    <div className={styles.noSubscription}>
      <p>
        You do not have an active subscription. Please subscribe to a plan to start sending
        campaigns.
      </p>
      <Button className={styles.button} onClick={handleClick} text="Buy subscription" />
    </div>
  );
};
